import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import { IconButton } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { selectWorkerServiceStatus, selectWorkerServiceStatusLoading } from '../../redux/workerServiceStatus/selectors';
import { selectCurrentCaseId } from '../../redux/currentCase/selectors';
import { getWorkerServiceStatus } from '../../redux/workerServiceStatus/thunks';
import SyncProblemIcon from '@material-ui/icons/SyncProblem';
import { AlertTitle } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: 10000,
    position: "absolute",
    top: "1rem",
    left: "15rem",
    padding: "0 0.5rem",
    height: "2.5rem",
    borderRadius: 4,
    display:"flex",
    alignItems: "center"
  },
  title:{
    padding: 0,
    margin: 0
  },
  icon:{
    padding: 0,
    margin: 0
  },
  iconButton:{
    margin: 0
  }
}));


function FactoryStatusAlert(){

  const dispatch = useDispatch();
  const styles = useStyles();
  const currentCase = useSelector(selectCurrentCaseId);
  const workerServiceStatus = useSelector(selectWorkerServiceStatus);
  const workerServiceStatusLoading = useSelector(selectWorkerServiceStatusLoading);
  const [showMessage, setShowMessage] = useState(false)
 

  useEffect(()=>{
    dispatch(getWorkerServiceStatus());
  },[currentCase])

  function showAlert(){
    if(workerServiceStatusLoading !== "succeeded")
      return false;

    if(!workerServiceStatus.isWorkerServiceRunning)
        return true

    if(workerServiceStatus.isFactoryShutDown)
        return true;

    return false;
   
  }

  function alertText(){

    if(!workerServiceStatus.isWorkerServiceRunning)
      return "El servicio de sincronización no está activo"

    if(workerServiceStatus.isFactoryShutDown)
        return "Error de conexión con Fábrica"

    return null
  }

    return(
       showAlert() &&
        <Alert classes={{root:styles.root, icon: styles.icon}} icon={<IconButton classes={{root: styles.iconButton}} onClick={()=>setShowMessage(!showMessage)}><SyncProblemIcon htmlColor='#fff' classes={{root: styles.icon}} fontSize='1.25rem'/></IconButton>} variant="filled" severity="error">
          {showMessage && <AlertTitle classes={{root: styles.title}}>{alertText()}</AlertTitle>}
        </Alert>
    )
}

export {FactoryStatusAlert}